var _defs, _line, _line2, _rect, _path, _path2, _path3, _path4, _rect2, _circle, _path5, _rect3, _line3, _line4, _line5, _line6, _line7, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.7 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;stroke-miterlimit:10;}.cls-1{stroke:#a3a3a3;stroke-linecap:round;}.cls-2{fill:#a3a3a3;}.cls-3{fill:#dab388;}.cls-4{fill:#414141;}.cls-5{fill:#d11414;}.cls-6{fill:#f1f1f1;}.cls-7{stroke:#414141;stroke-width:4px;}.cls-8{fill:#be2727;}.cls-9{fill:#f1c391;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.17,
    y1: 117.88,
    x2: 88.3,
    y2: 117.88
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.17,
    y1: 124.83,
    x2: 60.99,
    y2: 124.83
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.09,
    y: 0.65,
    width: 107.7,
    height: 151.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.36,33.74S159,55,152.93,59.33c0,0-3.63,2.07-9.52,1s-9.95-5.42-11.56-11.18c0,0-.49-3.93-.44-5.41,0,0-1.39-.53-1.7-1.47s-.8-8.89,1.21-9.38,3,.14,3.26,1.34l5.71-11.88,11.92-1.47L171,29.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.13,24.1S156.77,34.28,169,34.21a7.66,7.66,0,0,0,6.72-3.86,7.5,7.5,0,0,0-.52-8.06A5.28,5.28,0,0,0,171.33,20a11.19,11.19,0,0,0-1.83-3.44c-1.48-2-4.69-3.88-10.39-3.55a22.79,22.79,0,0,0-20.35-1.21,1.93,1.93,0,0,0-.7.49c-1.39,1.49-6.85,8.16-7.14,20.57,0,0,3.61-.82,3.41,3.26l-.33,1s.18,1.38,1.4.31a37.9,37.9,0,0,0,3.55-4s.27-4.82,1.34-6.09A15.77,15.77,0,0,0,147.13,24.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148.06,58s-2.81,4.08-3.95,12.12l-2.54,8-19-3.15,1.68-14.8s8.64-6.5,9.57-16.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.58,67.36S138,74.6,131.85,71.65s-6.66-9.51-6-12.86c0,0-11-2.81-13.83-3.48L106.13,158l6.43.35c.28,0,1.19-1.13,1.37-1.31,1.35-1.33,2.66-2.69,4-4.06,5-5.37,9.83-11,14.45-16.74,8.62-10.74,16.82-22.08,24.36-33.67a51.51,51.51,0,0,0,6.41-12.8A11.23,11.23,0,0,0,159,77c-4.06-2.77-8.19-5.44-12.27-8.18Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7.34,
    y: 7.71,
    width: 107.7,
    height: 151.64
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 43.09,
    cy: 44.76,
    r: 25.99
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.17,26s0,.06,0,.17a17.41,17.41,0,0,1-6.32,10.72l-.63-7Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 22.01,
    y: 36.92,
    width: 41.93,
    height: 15.36,
    rx: 5.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.3,
    y1: 76.74,
    x2: 95.98,
    y2: 76.74
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.3,
    y1: 82.63,
    x2: 95.98,
    y2: 82.63
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.3,
    y1: 103.26,
    x2: 95.98,
    y2: 103.26
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.3,
    y1: 110.9,
    x2: 95.98,
    y2: 110.9
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.3,
    y1: 88.53,
    x2: 68.99,
    y2: 88.53
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.52,82.6s-3.36-9.57-7-10.86c0,0-3.57-.22-5.49,1.07l-3,4.56s-3.35-.76-3.39.89c0,0-1.12,2.19,2.95,5.54a17.2,17.2,0,0,0,9.15,3.57l7.1-4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.55,55.19h4.82a0,0,0,0,1,0,0V80.91a2.31,2.31,0,0,1-2.31,2.31h-.19a2.31,2.31,0,0,1-2.31-2.31V55.19A0,0,0,0,1,70.55,55.19Z",
    transform: "translate(-26.91 81) rotate(-50.22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.75,81s-21.21,8.61-25,11.12c0,0-12-5.6-21.23-9.74a2.13,2.13,0,0,0-1.55,0A93.14,93.14,0,0,0,86.09,86,1.33,1.33,0,0,0,86,88.36c5.83,3.61,23.8,17,30.61,20,0,0,29.51-5.36,43.47-13.39,1.71-1,3.58-5.66,3.55-7.64C163.54,82.59,155.39,77.24,142.75,81Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168,34.14a21.48,21.48,0,0,1-.73,3.8,28.45,28.45,0,0,0,2.1-3.81C169.62,33.21,168,34.14,168,34.14Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsImg);
export default __webpack_public_path__ + "static/media/termsImg.b89aa783a8dc418c36a5a7e48247facb.svg";
export { ForwardRef as ReactComponent };